import React from "react";
import valueList from './cm_value_list.json';
import { getValueList, getGroupeInterpretation } from 'util/ValueList/Values';
import { displayEmoji } from '../displayEmoji';
import { Select, TreeSelect } from "antd";
import Parser from 'html-react-parser';

const Option = Select.Option;
const TreeNode = TreeSelect.TreeNode;

export function getTypeExtraitOptions(params = {}) {
  return (
    <Select
      showSearch
      optionFilterProp="children"
      placeholder={params.placeholder || ''}
    >
      {valueList.map((item) => {
        if (item.list_name === 'qf_type') {
          return (
            <Option value={Number(item.id_value)} key={item.id_value}>{(item.icon) ? displayEmoji(item.icon) : ""} {item.fr}</Option>
          );
        }
      })}
    </Select>
  );
}

export function getLangueOptions(params = {}) {
  return (
    <Select
      showSearch
      optionFilterProp="children"
      placeholder={params.placeholder || ''}
      mode={params.multiple ? 'multiple' : ''}
    >
      {valueList.map((item) => {
        if (item.list_name === 'qf_langue') {
          return (
            <Option value={Number(item.id_value)} key={item.id_value}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {(item.icon) ? <i className={`flag flag-16 gx-mr-2 ${item.icon}`} /> : ""} {item.fr}
              </div>
            </Option>
          );
        }
      })}
    </Select>
  );
}

export function getAgeExtraitOptions() {
  return (
    <Select
      showSearch
      optionFilterProp="children"
    >
      {valueList.map((item) => {
        if (item.list_name === 'qf_age') {
          return (
            <Option value={Number(item.id_value)} key={item.id_value}>{(item.icon) ? displayEmoji(item.icon) : ""} {item.fr}</Option>
          );
        }
      })}
    </Select>
  );
}

export function getTimbreExtraitOptions() {
  return (
    valueList.map((item) => {
      if (item.list_name === 'qf_timbre') {
        return (
          <Option value={Number(item.id_value)} key={item.id_value}>{(item.icon) ? displayEmoji(item.icon) : ""} {item.fr}</Option>
        );
      }
    })
  );
}

export function getInterpretationExtraitNode(group) {
  return (
    <TreeNode
      title={displayEmoji(getGroupeInterpretation(group).icon) + "  " + Parser(getGroupeInterpretation(group).title)}
      key={group}
      value={group}
      selectable={false}
    >
      {valueList.map((item) => {
        if (item.list_name === 'qf_interpretation') {
          return (
            (item.list_group === group) ?
              <TreeNode
                value={Number(item.id_value)}
                title={item.fr}
                key={item.id_value}
                isLeaf
                selectable={true}
              />
              : null
          );
        }
      })}
    </TreeNode>
  )

}

export function getDiffusionOptions(params = {}) {
  return (
    <Select
      showSearch
      optionFilterProp="children"
      placeholder={params.placeholder || ''}
    >
      {valueList.map((item) => {
        if (item.list_name === 'qf_diffusion') {
          return (
            <Option value={Number(item.id_value)} key={item.id_value}>{item.fr}</Option>
          );
        }
      })}
    </Select>
  )
}

export function getCachetOptions(params = {}) {
  const qfType = getValueList('qf_cachet');
  return (
    <Select
      showSearch
      optionFilterProp="children"
      placeholder={params.placeholder || ''}
    >
      {qfType.map((item) => {
        return (
          <Option value={Number(item.id_value)} key={item.id_value}>{Parser(item.fr)}</Option>
        );
      })}
    </Select>
  )
}

